export default __webpack_public_path__ + "static/media/grupos motorola.a847a632.png";